import { Box, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import useLanguageSkills from "../../../../../../hooks/useLanguageSkills";
import { Heading1, Text1 } from "../styled";
import { useFormContext } from "react-hook-form";

interface FormValues {
  id: string;
  name: string;
}

interface FormLanguages {
  languageCode: string;
  skillLevel: string;
}

const Requirements = () => {
  const { t } = useTranslation();

  const { watch } = useFormContext();
  const { certificates, languages, skills } = watch() as {
    orderTemplate: any;
    certificates: FormValues[];
    languages: FormLanguages[];
    skills: FormValues[];
  };

  const { getLanguageSkillsNameByCode } = useLanguageSkills();

  return (
    <>
      {certificates.length > 0 && (
        <>
          <Box sx={{ padding: "0px 0px 16px 16px" }}>
            <Heading1>{t("order:requirementsLong")}</Heading1>
            <Text1>
              {certificates
                .map((certificate) => certificate?.name || certificate.id)
                .join(" • ")}
            </Text1>
          </Box>

          <Divider sx={{ margin: "0 auto", width: "92%" }} />
        </>
      )}

      {skills.length > 0 && (
        <>
          <Box sx={{ padding: "0px 0px 16px 16px" }}>
            <Heading1>{t("order:requiredSkills")}</Heading1>
            <Text1>
              {skills.map((skill) => skill?.name || skill.id).join(" • ")}
            </Text1>
          </Box>

          <Divider sx={{ margin: "0 auto", width: "92%" }} />
        </>
      )}

      {languages.length > 0 && (
        <>
          <Box sx={{ padding: "0px 0px 16px 16px" }}>
            <Heading1>{t("order:languageSkills")}</Heading1>
            <Text1>
              {languages
                .map(
                  (language) =>
                    `${getLanguageSkillsNameByCode(language.languageCode)} (${t("languageSkill:" + language.skillLevel)})`,
                )
                .join(" • ")}
            </Text1>
          </Box>

          <Divider sx={{ margin: "0 auto", width: "92%" }} />
        </>
      )}
    </>
  );
};

export default Requirements;
